/** Webpack variable that injects the nonce value to all inserted script and style tags  */
// eslint-disable-next-line no-undef
__webpack_nonce__ = window.__cspNonce;
